import React from 'react'
import { useT } from '../lib/i18n'
import type { Alert } from '../lib/api'

interface Props {
  alerts: Alert[]
  onViewAll: () => void
}

export default function AlertBanner({ alerts, onViewAll }: Props) {
  const critical = alerts.filter((a) => a.severity === 'critical' || a.severity === 'high')
  const t = useT()

  if (critical.length === 0) return null

  const projects = [...new Set(critical.map((a) => a.projectId))].join(', ')

  return (
    <div
      role="alert"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '8px 16px',
        background: 'var(--health-crit-dim)',
        borderBottom: '1px solid var(--health-crit)',
        fontSize: '13px',
        color: 'var(--health-crit)',
        flexShrink: 0,
      }}
    >
      <span style={{ fontSize: '16px' }}>⚠</span>
      <strong>{t('critical_alert')}</strong>
      <span style={{ color: 'var(--text-muted)' }}>— {projects}</span>
      <span style={{ color: 'var(--text-muted)', fontSize: '11px' }}>
        ({critical.length} erreur{critical.length > 1 ? 's' : ''})
      </span>
      <button
        onClick={onViewAll}
        style={{
          marginLeft: 'auto',
          padding: '3px 10px',
          border: '1px solid var(--health-crit)',
          borderRadius: 'var(--radius)',
          background: 'transparent',
          color: 'var(--health-crit)',
          cursor: 'pointer',
          fontSize: '12px',
          fontFamily: 'var(--font-sans)',
        }}
      >
        {t('view_all')}
      </button>
    </div>
  )
}
